import React from 'react';

const copy: Record<string, { title: string; body: string }> = {
  photos: {
    title: 'Photos',
    body: 'Event photos will be listed and replaced from this screen. They currently load from the ImageKit events/images folder.',
  },
  carousel: {
    title: 'Carousel',
    body: 'Homepage carousel slides will be edited here. They currently use the banner images on the public site.',
  },
  content: {
    title: 'Content',
    body: 'Page text for about, causes, team, and testimonials will be edited here.',
  },
  messages: {
    title: 'Messages',
    body: 'Contact form submissions will appear here after the contact_messages table is created in Supabase.',
  },
};

const AdminSection: React.FC<{ section: keyof typeof copy }> = ({ section }) => {
  const page = copy[section];
  return (
    <div className="tw-max-w-2xl">
      <h1 className="tw-text-3xl tw-font-semibold">{page.title}</h1>
      <p className="tw-mt-3 tw-text-sm tw-leading-6 tw-text-muted-foreground">{page.body}</p>
    </div>
  );
};

export default AdminSection;
